/* eslint-disable no-new,max-classes-per-file,no-use-before-define */
import $ from 'jquery';

export default class Countdown {
  constructor() {
    this.$countdown = $('.js-countdown');
    this.init();
  }

  init() {
    this.isInitialized = true;

    if (!this.$countdown.length) {
      this.isInitialized = false;
      return;
    }

    this.$countdown.each((i, el) => {
      new CountdownInstance($(el));
    });
  }

  static getCountdownTime(countdownSec) {
    const days = Math.floor(countdownSec / 86400);
    const hours = Math.floor((countdownSec - days * 86400) / 3600);
    const minutes = Math.floor((countdownSec - days * 86400 - hours * 3600) / 60);
    const seconds = countdownSec - days * 86400 - hours * 3600 - minutes * 60;

    return {
      days,
      hours,
      minutes,
      seconds,
    };
  }

  static setExtraZero(number) {
    return number.toString().length < 2 ? `0${number}` : `${number}`;
  }

  static getCountdownSecToEvent(countdownTime) {
    return Math.floor((new Date(countdownTime) - Date.now()) / 1000);
  }

  static isValidDateString(dateString) {
    const date = Date.parse(dateString);
    return new Date(date) instanceof Date && !Number.isNaN(date);
  }
}

export class CountdownInstance {
  constructor($container) {
    this.$container = $container;
    this.init();
  }

  init() {
    if (this.$container) {
      this.countdownEventTime = this.$container.find('[data-countdown-event-time]').data('countdown-event-time');
      if (!this.countdownEventTime) return;
      if (!Countdown.isValidDateString(this.countdownEventTime)) {
        console.error('Cant parse the date, invalid date value');
        return;
      }

      // consider client timezone offset
      this.countdownIsUTC = this.$container.data('countdown-is-utc');
      if (!this.countdownIsUTC) {
        const userTimezoneOffsetMs = new Date().getTimezoneOffset() * -60000;
        if (Math.abs(userTimezoneOffsetMs)) {
            const adjustedCountdownEventTime = (new Date(this.countdownEventTime)).getTime() + userTimezoneOffsetMs;
            this.countdownEventTime = new Date(adjustedCountdownEventTime);
        }
      }

      this.$countdownDay = this.$container.find('.js-countdown-day');
      this.$countdownHour = this.$container.find('.js-countdown-hour');
      this.$countdownMin = this.$container.find('.js-countdown-min');
      this.$countdownSec = this.$container.find('.js-countdown-sec');

      this.tickCountdown();
      this.setCountdownInterval();
      this.checkToHide();
    }
  }

  clearCountdown() {
    this.setCountdown({
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',
    });
  }

  setCountdown(time) {
    this.$countdownDay.text(Countdown.setExtraZero(time.days));
    this.$countdownHour.text(Countdown.setExtraZero(time.hours));
    this.$countdownMin.text(Countdown.setExtraZero(time.minutes));
    this.$countdownSec.text(Countdown.setExtraZero(time.seconds));
  }

  tickCountdown() {
    const countdownSec = Countdown.getCountdownSecToEvent(this.countdownEventTime);
    if (countdownSec <= 0) {
      this.clearCountdownInterval();
      this.clearCountdown();
    } else {
      const time = Countdown.getCountdownTime(countdownSec);
      this.setCountdown(time);
    }
  }

  setCountdownInterval() {
    this.countdownInterval = setInterval(() => {
      this.tickCountdown();
    }, 1000);
  }

  clearCountdownInterval() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  checkToHide() {
    const hide = this.$container.data('hide-when-finished');
    const hideAfter = this.$container.data('hide-after');
    const timeToHide = this.countdownEventTime;
    let $containerToHide;

    if (this.$container.closest('.super-banner__footer--countdown').length) {
      $containerToHide = this.$container.closest('.super-banner__footer--countdown');
    } else if (this.$container.closest('.countdown-content').length) {
      $containerToHide = this.$container.closest('.countdown-content');
    } else if (this.$container.closest('.ff-component').length) {
      $containerToHide = this.$container.closest('.ff-component');
    }
    if (hide === 'True' && $containerToHide) {
      setInterval(() => {
        if ((new Date(timeToHide)).getTime() + (hideAfter * 60000) < Date.now()) {
          $containerToHide.hide();
        }
      }, 30000);
    }
  }
}
